import "./Speaker.scss";
import { HiChevronDoubleDown } from "react-icons/hi";
import { FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { useGlobalContext } from "../../contexts/context";
import { speakerData } from "../../data/data";
import { Link as Scroll } from "react-scroll";
import Modal from "../../components/Modal/Modal";
import { Link } from "react-router-dom";
import Banner from "../../components/Banner";

const SpeakerPage = () => {
  const { modalOpen, selectedTeamMember, handleTeamMemberClick, handleModalClose } = useGlobalContext();

  return (
    <>
      <section className="header-bg section">
        <div className="banner">
          <Banner />
        </div>
        <article className="header-bg__container">
          <div className="header-bg__container-contents">
            <h1 className="">Speakers Coming Soon</h1>
            <p>Stay tuned for updates on our amazing lineup of TEDxOAU speakers!</p>
          </div>

          <Scroll
            to="next-section"
            smooth={true}
            duration={100}
            delay={0}
            offset={100}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="scroll-btn">
              <HiChevronDoubleDown />
              <span>Scroll Down</span>
            </div>
          </Scroll>
        </article>
      </section>

      <section className="section speaker" id="next-section">
        <article className="speaker__container container">
          <p className="speaker__container--desc">
            Our TEDxOAU speakers are visionary leaders in their respective fields, contributing to our mission of inspiring change and
            fostering innovation. They bring a wealth of expertise and insights that have a profound impact on our community. These speakers
            are not just presenters; they are thought leaders who actively engage in meaningful discussions, challenge boundaries, and push
            our mission forward. Their dedication and passion are instrumental in helping us create a better city and a better world. We are
            privileged to have these speakers as integral members of the TEDxOAU family. Their contributions are immeasurable, and they
            continue to play crucial roles in our journey toward positive change and progress. Join us as we explore the world through the
            unique perspectives of our TEDxOAU speakers and be prepared to be inspired, educated, and engaged.
          </p>

          <div className="speaker__container-contents">
            {speakerData.map((teamMember) => {
              const { id, name, role, image, linkedin, instagram, twitter } = teamMember;
              return (
                <div key={id} className="speaker__contents-body" data-aos="fade-down" onClick={() => handleTeamMemberClick(teamMember)}>
                  <div className="speaker__body-menu"></div>
                  <div>
                    <span className="speaker__list">
                      <span className="speaker__item">
                        <img src={image} alt={name} />
                      </span>
                    </span>
                  </div>
                  <div className="speaker__bio">
                    <h3>{name}</h3>
                    <p>{role}</p>
                    <div className="speaker__socials">
                      <Link to={linkedin} target="_blank" onClick={(e) => e.stopPropagation()}>
                        <FaLinkedin />
                      </Link>
                      <Link to={instagram} target="_blank" onClick={(e) => e.stopPropagation()}>
                        <FaInstagram />
                      </Link>
                      <Link to={twitter} target="_blank" onClick={(e) => e.stopPropagation()}>
                        <FaTwitter />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </article>
      </section>

      <Modal selectedTeamMember={selectedTeamMember} handleClose={handleModalClose} modalOpen={modalOpen} />
    </>
  );
};

export default SpeakerPage;
